import { render, staticRenderFns } from "./EntityColumnConfig.vue?vue&type=template&id=e913a99a&scoped=true"
import script from "./EntityColumnConfig.vue?vue&type=script&lang=js"
export * from "./EntityColumnConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e913a99a",
  null
  
)

export default component.exports